import {Component, tag} from 'doz'
import adapters from './adapters'
import logoUrl from '../../../resources/default-cover.png'
import ellipsis from 'text-ellipsis'

@tag('speaker')
export default class extends Component {
    props = {
        feed:[],
        title: '',
        imageUrl: '',
        content: '',
        defaultCover: logoUrl,
    };

    propsConvert = {
        content: v => ellipsis(v, 50)
    };

    template(h) {
        return h`
            <style>
                .container{
                    color: ${this.PLAYER_CONFIG.programOnAirTextColor || this.THEME.onPrimaryColor};
                    background: ${this.PLAYER_CONFIG.programOnAirBackgroundColor || this.THEME.primaryColor};
                    border-color: ${this.PLAYER_CONFIG.programOnAirSeparatorColor || ''};
                    text-align:left;
                    display: flex;
                    align-items: center;
                    min-height: 190px;
                    ${this.PLAYER_CONFIG.programOnAirBackgroundImageUrl ? `background-image: url("${this.PLAYER_CONFIG.programOnAirBackgroundImageUrl}");` : ''}
                    background-size: cover;
                }

                .img {
                    width: ${!!(this.props.title || this.props.content) ? '120px' : '100%'};
                    margin-right: ${!!(this.props.title || this.props.content) ? '16px' : '0'};
                    border-radius: 8px;
                    border: 2px solid ${this.PLAYER_CONFIG.programOnAirImageBorderColor || this.THEME.onPrimaryColorAlpha};
                    min-width: 120px;
                    min-height: ${this.PLAYER_CONFIG.programOnAirCustomButtonActive ? '100px' : '80px'};
                    object-fit: cover;
                    object-position: top;
                    background: ${this.PLAYER_CONFIG.programOnAirImageBackgroundColor ? this.PLAYER_CONFIG.programOnAirImageBackgroundColor : 'transparent'};
                }
                
                .column-left {
                    margin: ${!!(this.props.title || this.props.content) ? '0' : 'auto'};
                }
                
                .on-air {
                    background: ${this.PLAYER_CONFIG.programOnAirLabelBackgroundColor || this.THEME.onPrimaryColor};
                    color: ${this.PLAYER_CONFIG.programOnAirLabelTextColor || this.THEME.primaryColor};
                    padding: 4px;
                    border-radius: 4px;
                    display: inline-block;
                    margin-bottom: 8px;
                    text-transform: uppercase;
                    font-size: 12px;
                    font-weight: bold;
                }

                .title {
                    font-weight: bold; 
                    text-transform: uppercase;
                    margin-bottom: 4px;
                }
                
                .content {
                    font-size: 12px;
                    opacity: 0.7;
                }
                
                .button-custom {
                    background: ${this.PLAYER_CONFIG.ProgramOnAirCustomButtonBackgroundColor || this.THEME.onPrimaryColor};
                    color: ${this.PLAYER_CONFIG.ProgramOnAirCustomButtonTextColor || this.THEME.primaryColor};
                    border: none;
                    padding: 6px;
                    border-radius: 4px;
                    margin-top: 6px;
                    font-weight: bold;
                    text-decoration: none;
                    text-transform: uppercase;
                    font-size: 14px;
                    display: inline-block;
                }
                
                .button-custom i {
                    margin-right: 6px;
                    font-size: 18px;
                }
            </style>
            <div class="container">
                <div d-show="${!!this.props.imageUrl}" class="column-left">
                    <img class="img animated fadeIn" src="${this.props.imageUrl}">
                </div>
                <div class="animated fadeIn column-right" d-show="${!!(this.props.title || this.props.content)}">
                    <div class="on-air">Ora in onda</div>
                    <div class="title">${this.props.title}</div>
                    <div class="content">${this.props.content}</div>
                    <a 
                        class="button-custom"
                        href="${this.PLAYER_CONFIG.programOnAirCustomButtonActionUrl || '#'}" 
                        target="${this.PLAYER_CONFIG.programOnAirCustomButtonActionUrl ? '_blank' : '_self'}"
                        d-show="${this.PLAYER_CONFIG.programOnAirCustomButtonActive}">
                        <i class="${this.PLAYER_CONFIG.programOnAirCustomButtonIcon}"></i>
                        ${this.PLAYER_CONFIG.programOnAirCustomButtonText}
                    </a>
                </div>
            </div>
        `
    }

    onMountAsync() {
        if (this.isSSR()) return;
        this.getData();
        setInterval(() => this.getData(),10000);
    }

    getData(){
        const url = this.PLAYER_CONFIG.programOnAirUrl;

        // Special case, solo immagine come Radio Deejay
        if (this.PLAYER_CONFIG.programOnAirType === 'IMAGE') {
            this.props.imageUrl = url + '?' + (new Date()).getTime();
            return;
        }

        const adapter = adapters[this.PLAYER_CONFIG.programOnAirType];
        if (!adapter) return;

        this.axios.get(this.CORS_PROXY + url)
            .then(response => {
                if(response.data){
                    adapter(response.data, this.props);
                }
            })
            .catch (error => {
                console.error(error);
            });
    }

}
